import React from 'react';
import { T, gradeFor, gradeInkFor, UNGRADED, STATUS_COLORS, STATUS_LABELS } from '../designTokens';

// ---------------------------------------------------------------------------
// Status badge
// ---------------------------------------------------------------------------

/** `score` is null for a scan that assessed nothing (see isUngraded). */
export function GradeBadge({ score }: { score: number | null }) {
  const { letter: grade, bg } = score === null ? UNGRADED : gradeFor(score);
  const color = score === null ? UNGRADED.color : gradeInkFor(score);
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '2px 8px',
      borderRadius: '9999px',
      backgroundColor: bg,
      color,
      fontWeight: 700,
      fontSize: '12px',
      fontFamily: T.fontMono,
    }}>
      {score === null ? grade : `${grade} · ${score}`}
    </span>
  );
}

export function StatusBadge({ status }: { status: string }) {
  // An unknown status (a value the backend added before this client knew it)
  // keeps its text but reads as neutral, never as a red failure pill.
  const known = (STATUS_COLORS as Record<string, { bg: string; text: string }>)[status];
  const colors = known ?? { bg: T.gray100, text: T.gray600 };
  const label = (STATUS_LABELS as Record<string, string>)[status] ?? status;
  return (
    <span style={{
      padding: '2px 8px',
      borderRadius: '9999px',
      backgroundColor: colors.bg,
      color: colors.text,
      fontWeight: 600,
      fontSize: '12px',
      fontFamily: T.fontMono,
      letterSpacing: '0.03em',
    }}>
      {label}
    </span>
  );
}

export const thStyle: React.CSSProperties = {
  textAlign: 'left',
  padding: '10px 12px',
  fontWeight: 600,
  color: T.gray400,
  borderBottom: `1px solid ${T.gray200}`,
  fontSize: '12px',
  fontFamily: T.fontMono,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
};

export const tdStyle: React.CSSProperties = {
  padding: '12px',
  color: T.gray700,
  verticalAlign: 'middle',
};
